import { FC, useCallback, useEffect } from "react";

import { useSearchParams } from "next/navigation";
import { I18nUtil } from "@utils/i18n";
import { RedeemCodeModalCreateAble } from "@/src/components/modal/RedeemCode";
import Translations from "@translate/components/Member/CurrentPlan/GiftCodeSection";
import { ROUTER_PATH } from "@/src/config";
const I18n = I18nUtil.createScoped(Translations);

/**
 * 礼品码兑换入口组件
 * 基于Figma设计稿实现底部文案和兑换入口
 */
export const GiftCodeSection: FC = () => {
  const searchParams = useSearchParams();
  const inviteSpreadCode = searchParams.get("inviteSpreadCode");
  // 处理兑换码点击
  const handleConvertClick = useCallback(async () => {
    await RedeemCodeModalCreateAble({ code: inviteSpreadCode });
  }, [inviteSpreadCode]);

  useEffect(() => {
    if (!!inviteSpreadCode && !!inviteSpreadCode.trim()) {
      handleConvertClick();
      history.replaceState({}, "", ROUTER_PATH.MEMBER);
    }
  }, [inviteSpreadCode, handleConvertClick]);

  return (
    <div className="flex flex-col items-center justify-center p-4 md:py-10 md:px-0 w-full">
      <div className="flex body_bold_m md:body_medium_l gap-[12px] items-center text-center">
        <p className="text-content_primary">{I18n.t("Have a Gift Code？")}</p>
        <button
          aria-label="Gift Code Section"
          data-openreplay-label={`Gift Code Section Button | ${I18n.t("Convert")}`}
          id="btn-gift-code-section"
          onClick={handleConvertClick}
          className="text-content_brand_primary underline hover:text-content_brand_primary_hover transition-colors cursor-pointer bg-transparent border-none p-0"
        >
          {I18n.t("Convert")}
        </button>
      </div>
    </div>
  );
};
